import Payment from "../payment/Payment";

class OrderPayment extends Payment {
  constructor(props: any) {
    super(props.paymentId, props);
  }
}

export default OrderPayment;
